import React, { useState } from "react";
import { Col, Row, Button, Form } from "react-bootstrap";
import { FaPlusCircle, FaSync } from "react-icons/fa";
import TagForm from "./TagForm";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import Skeleton from "react-loading-skeleton";
import Message from "./Message";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";
import ClinicFollowupForm from "./ClinicFollowupForm";

const ClinicFollowups = ({ clinicFollowups, setClinicFollowups, clinicId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const addFollowup = () => {
    setClinicFollowups([
      ...clinicFollowups,
      {
        idx: Math.random(),
        label: "",
        upperLimit: "0",
        lowerLimit: "10",
        isHide: false,
      },
    ]);
  };
  const dispatch = useDispatch();
  const updateClinicFollowups = async () => {
    // update Scans
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/updateClinicFollowups`,
        {
          clinicFollowups,
        },
        config,
      );
      setClinicFollowups(data.updatedClinicFollowups);
      setLoading(false);
      dispatch({ type: CLINIC_DETAILS_RESET });

      notify({
        title: "Followups Update Status",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };
  return (
    <div>
      {loading ? (
        <Skeleton height="50px" count={3} />
      ) : error ? (
        <Message children={error} variant={`danger`} />
      ) : (
        <>
          <h3>Follow-up Items</h3>
          <Row>
            <Col className="col-6">
              <Form.Label>Follow-up Item</Form.Label>
            </Col>
            <Col className="col-2">
              <Form.Label> Upper Limit </Form.Label>{" "}
            </Col>
            <Col className="col-2">
              <Form.Label>Lower Limit</Form.Label>{" "}
            </Col>
            <Col className="col-2"> </Col>
          </Row>
          {clinicFollowups
            .filter((f) => !f.isHide)
            .map((f) => (
              <div key={f._id}>
                <ClinicFollowupForm followupItem={f} clinicId={clinicId} />
              </div>
            ))}

          <Button
            className="btn-secondary w-100 my-3"
            onClick={() => addFollowup()}
          >
            <FaPlusCircle className="ms-2" /> Add New Item
          </Button>
          {!loading && (
            <div className="d-flex justify-content-end mt-3 width-100">
              <div>
                <Button
                  variant="outline-info"
                  onClick={() => updateClinicFollowups()}
                >
                  <FaSync /> Update
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ClinicFollowups;
